import React from 'react';
import { Field } from 'redux-form';
import range from 'lodash.range';
import Input from '../Forms/Input';
import styles from './AdditionalInformationFields.css';
import required from '../../utils/fieldRequired';
import trimWhiteSpace from '../../utils/trimWhiteSpace';

const datesOptions = range(2020, 1930).map(i => ({
    value: i,
    text: i,
    key: i,
}));

const validateMobile = (value) => {
    if (value == null && trimWhiteSpace(value) === '') {
        return undefined;
    }

    if (!/^\d{10}$/.test(value)) {
        return 'Please enter valid phone number';
    }
    return undefined;
};


const NorthEastAdditionalInformationFields = () => (<div>
    <div className={styles.row}>
        <Field
            name="dateOfBirth"
            label="Date of Birth"
            component={Input}
            mask="mm/dd/yyyy"
            placeholder="mm/dd/yyyy"
            className={styles.input_half_width}
            validate={required}
            options={datesOptions}
        />
    </div>
    <div className={styles.row}>
        <Field
            name="mobilePhone"
            label="Mobile Phone"
            component={Input}
            className={styles.input}
            validate={validateMobile}
        />
    </div>
</div>);

NorthEastAdditionalInformationFields.propTypes = {};

export default NorthEastAdditionalInformationFields;



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/NorthEastAdditionalInformationfields.js